"use strict";
/* eslint-disable complexity */
/* eslint-disable no-console */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbUSDAuthenticator = void 0;
const web_ui_security_1 = require("@gruposantander/web-ui-security");
const types_1 = require("../../../security/session/cc/types");
const helper_1 = require("../cc/helper");
//TODO Authenticator only for model or not??
class MbUSDAuthenticator extends web_ui_security_1.BaseAuthenticator {
    constructor(session, xhr, modelbankUSDManager) {
        super(session);
        this.doLogout = async () => {
            const sessionData = this.getSession().getData();
            const accessToken = sessionData?.accessToken;
            const headers = {
                accessToken: sessionData?.agentToken,
            };
            await this.xhr.POST(`${window.MIDDLEWARE_BASE_HOST}/mb-api-auth/authentication/logout`, { accessToken }, headers);
        };
        this.doLogin = async () => {
            const data = await this.modelbankUSDManager.init();
            if (data) {
                return {
                    accessToken: data.securitySSR_AccessToken,
                    refreshToken: data.securitySSR_RefreshToken,
                    agentToken: data.agentToken,
                    username: data.userName,
                    expiresIn: 5000,
                    sessionExpiresAt: (0, helper_1.createSessionExpiresAt)(),
                    entrypoint: types_1.EntrypointType.USD,
                };
            }
            return null;
        };
        this.xhr = xhr;
        this.modelbankUSDManager = modelbankUSDManager;
    }
}
exports.MbUSDAuthenticator = MbUSDAuthenticator;
//# sourceMappingURL=index.js.map